module.exports = "HrDashboard";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/hr/hr.dashboard.html
// module id = 446
// module chunks = 0